import _ from 'lodash'

export function enumclass(config) {
  const self = { config }

  const valueToName = {}
  _.forEach(Object.entries(config), ([name, value]) => {
    self[name] = value
    valueToName[value] = name
  })

  self.nameOf = function nameOf(value) {
    return valueToName[value]
  }

  return self
}
